import React from 'react';
import { Link } from 'react-router-dom';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Card } from '../components/ui/Card';
import { Activity, Scissors, User, CircleDot, AlertCircle, Bone, Ear } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function SpecialtiesPage() {
  const {
    t
  } = useLanguage();
  const specialties = [{
    name: t.specialties.items.general.name,
    desc: t.specialties.items.general.desc,
    icon: Activity
  }, {
    name: t.specialties.items.laparoscopic.name,
    desc: t.specialties.items.laparoscopic.desc,
    icon: Scissors
  }, {
    name: t.specialties.items.urological.name,
    desc: t.specialties.items.urological.desc,
    icon: User
  }, {
    name: t.specialties.items.colorectal.name,
    desc: t.specialties.items.colorectal.desc,
    icon: CircleDot
  }, {
    name: t.specialties.items.oncological.name,
    desc: t.specialties.items.oncological.desc,
    icon: AlertCircle
  }, {
    name: t.specialties.items.orthopedic.name,
    desc: t.specialties.items.orthopedic.desc,
    icon: Bone
  }, {
    name: t.specialties.items.ent.name,
    desc: t.specialties.items.ent.desc,
    icon: Ear
  }];
  return <div className="pt-20" data-id="element-693">
      {/* Hero */}
      <div className="bg-caces-navy text-white py-20" data-id="element-694">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-695">
          <h1 className="font-serif text-4xl md:text-5xl font-bold mb-4" data-id="element-696">
            {t.specialties.hero.title}
          </h1>
          <p className="text-xl text-caces-light max-w-2xl mx-auto" data-id="element-697">
            {t.specialties.hero.subtitle}
          </p>
        </div>
      </div>

      {/* Specialties List */}
      <section className="py-16 bg-white" data-id="element-698">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-699">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-700">
            {specialties.map((spec, index) => <Card key={index} className="flex flex-col h-full overflow-hidden group" data-id="element-701">
                <div className="bg-caces-sky p-6 flex justify-center items-center group-hover:bg-caces-blue transition-colors duration-300" data-id="element-702">
                  <spec.icon size={48} className="text-caces-navy group-hover:text-white transition-colors duration-300" data-id="element-703" />
                </div>
                <div className="p-8 flex-grow flex flex-col" data-id="element-704">
                  <h3 className="font-serif text-xl font-bold text-caces-navy mb-3" data-id="element-705">
                    {spec.name}
                  </h3>
                  <p className="text-gray-600 mb-6 flex-grow" data-id="element-706">{spec.desc}</p>
                  <Link to="/contact" className="mt-auto" data-id="element-707">
                    <span className="text-caces-accent font-medium hover:text-caces-blue flex items-center gap-2" data-id="element-708">
                      {t.specialties.inquire} &rarr;
                    </span>
                  </Link>
                </div>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="py-12 bg-gray-50" data-id="element-709">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-710">
          <div className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm" data-id="element-711">
            <p className="text-gray-600 text-sm" data-id="element-712">
              <strong data-id="element-713">{t.specialties.disclaimer}</strong>
            </p>
          </div>
        </div>
      </section>
    </div>;
}